<template>

<div class="chart">

    <div class="chart-type is-fore">
    
        <div class="chart-item" v-for="(item, index) in results" :key="index">
        
             <div class="chart-item-value is-green" :style="{height: item.success.toString() + '%'}" v-tooltip="item.label"></div>
             <div class="chart-item-value is-red" :style="{height: item.failed.toString() + '%'}" v-if="item.failed"></div>

        </div>
    
    </div>

</div>

</template>

<script>

import _ from 'underscore'

export default {

    props: ['data', 'width'],

    computed: {

        results: function() {

            var results = []

            var columns = Math.ceil(this.width / 9)

            var hourly = this.data.hourly.slice(0, columns)

            var max = _.max(hourly, function(item) {

                return item.results

            }).results

            _.each(hourly, function(item) {

                var total = item.success + item.failed

                results.push({
                    label: total.toString() + ' ' + ((total === 1) ? 'sync' : 'syncs'),
                    success: (100 / max) * item.success,
                    failed: (100 / max) * item.failed
                })

            })

            return results.reverse()

        }

    },

    methods: {

        filter: function(name, value, param) {

			return this.$options.filters[name](value, param)

		}

    }

}

</script>

<style scoped>

.chart {
    position: absolute;
    left: 0px;
    bottom: 0%;
    right: 0px;
}

.is-tablet .chart,
.is-mobile .chart {
    position: relative;
    left: auto;
    bottom: auto;
    right: auto;
}

.chart-type {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    position: absolute;
    left: 0px;
    bottom: 0px;
}

.chart-type.is-fore {
    z-index: 2;
    height: calc(50vh - 160px);
    margin-top: 20px;
}

.is-tablet .chart-type.is-fore {
    height: 160px;
    position: relative;
    left: auto;
    bottom: auto;
}

.is-mobile .chart-type.is-fore {
    height: 160px;
    position: relative;
    left: auto;
    bottom: auto;
}

.chart-item {
    width: 8px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin-left: 1px;
}

.chart-item-value {
    width: 8px;
    height: 0%;
}

.chart-item-value.is-shade {
    background-color: rgba(0, 0, 0, 0.15);
}

.chart-item-value.is-green {
    background-color: #ffc563;
}

.chart-item-value.is-green:hover  {
    background-color: #e1aa4d;
}

.chart-item-value.is-red {
    background-color: #ff6363;
    margin-top: 1px;
}

.chart-item:hover .chart-item-value.is-red {
    background-color: #da4949;
    margin-top: 1px;
}

</style>
